import React from "react";
import { Typography, Box } from "@mui/material";

const sx = {
  section: {
    maxWidth: "980px",
    borderRadius: "8px",
    gap: "40px",
    padding: "40px 0px 40px 0px"
  },
  header: {
    display: "flex",
    alignItems: "center",
    padding: "0px 20px 0px 20px",
    height: "50px",
    color: "blue.c100",
    backgroundColor: "blue.c20",
    borderRadius: "8px 8px 0px 0px"
  },
  content: {
    padding: "20px",
    backgroundColor: "common.white",
    borderBottom: (theme) => `1px solid ${theme.palette.blue.c20}`,
    "&:last-child": {
      borderBottom: "none",
      borderBottomLeftRadius: "8px",
      borderBottomRightRadius: "8px"
    }
  }
};

function Section({ pageData, children }) {
  return (
    <Box sx={sx.section}>
      <Box sx={sx.header}>
        <Typography variant="body1B">{pageData?.headerItems}</Typography>
      </Box>
      {children?.map((child, index) => (
        <Box key={index} sx={sx.content}>
          {child}
        </Box>
      ))}
    </Box>
  );
}

export default Section;
